<template lang="pug">
#lista-erros
    section#base-header.erros-lista
        span {{ $t('mensagens.operacao.dashboard.erroBase') }}
        span {{ $t('mensagens.operacao.dashboard.data') }} {{ data }}

    section.lista-monitoramentos__tabela
        el-table(
            :data='erros',
            stripe,
            height='calc(100% - 48px)',
            @sort-change='ordenar',
            v-loading='carregandoTabela'
        )
            el-table-column(:label="$t('mensagens.operacao.tabela.base')", sortable)
                template(slot-scope='scope')
                    span {{ scope.row.base }}
            el-table-column(
                :label="$t('mensagens.operacao.tabela.dataUltimaVerificacao')",
                align='center',
                sortable
            )
                template(slot-scope='scope')
                    span {{ scope.row.dataUltimaverificacao }}

            el-table-column(
                :label="$t('mensagens.operacao.tabela.dataVerificacaoLyra')",
                align='center',
                sortable
            )
                template(slot-scope='scope')
                    span {{ scope.row.dataVerificacaoLyra }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoService from '@/services/OperacaoService';

export default {
    name: 'ErrosMonitoramentoOperacaoBase',

    components: {
        BaseHeader
    },

    data() {
        return {
            data: '09/08/2023',
            erros: [],
            carregandoTabela: false,
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            }
        };
    },

    mounted() {
        // buscar erros no back
    },

    methods: {
        ordenar(props) {
            this.paginacao.direcao = props.order;
            this.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.paginacao.ordernarPor = null;
            this.buscarErros(0);
        },

        async buscarErros(pagina) {
            this.carregandoTabela = true;
            this.paginacao.pagina = pagina;

            await OperacaoService.buscarErros(this.paginacao).then(
                ({ data }) => {
                    this.erros = data.itens;

                    this.paginacao.pagina = data.paginacao.pagina + 1;
                    this.paginacao.total = data.paginacao.total;
                    this.paginacao.itensPorPagina =
                        data.paginacao.itensPorPagina;
                    this.paginacao.totalPaginas = data.paginacao.totalPaginas;
                }
            );

            this.carregandoTabela = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.lista-monitoramentos__barra-pesquisa {
    display: flex;
    justify-content: flex-start;
    gap: 2%;
    padding-left: 2%;
    height: 5vw;
    align-items: center;
}

.lista-monitoramentos__tabela {
    padding: 2%;
    padding-top: 0;
}

.erros-lista {
    height: 7vh;
    margin-bottom: 2%;
    padding-left: 2%;
    display: flex;
    align-items: center;
    gap: 45%;
    font-weight: bold;
    font-size: large;
}
</style>
